import * as S from './styles';
import { useAppContext } from 'src/components/app-context';
import React from 'react';
import { NoResults } from '../../../components/no-results';
import { PopularSearches } from '../../../components/popular-searches';
import type { KeywordLandingPageQuery } from '../../../types';

interface Props {
  popularSearches: KeywordLandingPageQuery['popularSearches'];
}

export const NoItems = ({ popularSearches }: Props) => {
  const { t } = useAppContext();

  return (
    <>
      <NoResults title={t('category', 'keyword-landing-page.no-offers')} />
      {popularSearches?.length ? (
        <>
          <S.PopularSearchesTitle>
            {t('search', 'search.popular-searches')}
          </S.PopularSearchesTitle>
          <PopularSearches popularSearches={popularSearches} />
        </>
      ) : null}
    </>
  );
};
